const product = {
  information: "Em formação", // translated
  additionalInformation: "informação adicional", // translated
  contactUs: "Entre em contato conosco", // translated
  contactUsText: "Quer personalizar seu passeio ou tem alguma outra dúvida?", // translated
  dropUsAnEmail: "Mande-nos um e-mail", // translated
  viewLess: "Ver menos", // translated
  viewMore: "Veja mais", // translated
  less: "menos", // translated
  more: "mais", // translated
  highlights: "Destaques", // translated
  inclusions: "Inclusões", // translated
  exclusions: "Exclusões", // translated
  pleaseWait: "Por favor, espere...", // translated
  tourType: "Tipo de passeio", // translated
  search: "Procurar", // translated
  available: "Disponível", // translated
  availableTours: "Passeios Disponíveis", // translated
  sortBy: "ORDENAR POR", // translated
  priceLowToHigh: "Preço: Baixo a Alto", // translated
  priceHighToLow: "Preço: alto a baixo", // translated
  mostPopular: "Mais popular", // translated
  roomOnly: "Apenas quarto", // translated
  bedAndBreakfast: "Alojamento e pequeno-almoço", // translated
  halfBoard: "Meia pensão", // translated
  fullBoard: "Pensão completa", // translated
  allInclusive: "Tudo Incluído", // translated
  viewDetails: "Ver detalhes", // translated
  close: "Perto", // translated
  at: "Não", // translated
  person: "pessoa", // translated
  cancellationPolicy: "Política de cancelamento", // translated
  cancellationIs: "cancelamento é", // translated
  to: "para", // translated
  bookingRemarks: "Reservas Observações", // translated
  totalPrice: "Preço total", // translated
  back: "Costas", // translated
  bookNow: "Agende agora", // translated
  minutes: "Minutos", // translated
  visitDuration: "Duração da visita", // translated
  itinerary: "Itinerário", // translated
  airportToHotel: "Aeroporto para hotel", // translated
  hotelToAirport: "Hotel para aeroporto", // translated
  details: "detalhes", // translated
  servicesDetails: "Detalhes dos serviços", // translated
  services: "Serviços", // translated
  day: "Dia", // translated
  next: "Próximo", // translated
  nextStep: "Próxima Etapa", // translated
  skip: "Pular", // translated
  remarks: "Observações", // translated
  optional: "opcional", // translated
  guests: "Convidados", // translated
  payment: "Pagamento", // translated
  pickup: "escolher", // translated
  featuredPackage: "Pacote em destaque", // translated
  flights: "Voos", // translated
  accommodation: "Alojamento", // translated
  transfers: "Transferências", // translated
  tours: "Passeios", // translated
  experiences: "Experiências", // translated
  featuredTour: "Tour em destaque", // translated
  From: "A partir de", // translated
  Accommodation: "Alojamento", // translated
  approxDuration: "Aproximadamente. duração", // translated
  travellerInformation: "Informações do viajante", // translated
  bookingOverview: "Visão geral da reserva", // translated
  checkout: "Confira", // translated
  paymentFailed: "Pagamento falhou", // translated
  paymentSuccess: "Sucesso do pagamento", // translated
  night: "Noite", // translated
  viewEscapes: "Ver Fuga", // translated
  escapeType: "Tipo de escape", // translated
  adultsOnly: "Somente adultos", // translated
  totalDuration: "Duração total", // translated
  product: "produtos", // translated
  nights: "Noites", // translated
  departingAirport: "Aeroporto de partida", // translated
  viewExperience: "Ver experiência", // translated
  products: "Produtos", // translated
  childrenAreNotAllowedInThisTour: "Crianças não são permitidas neste passeio", // translated
  options: "Opções", // translated
};


export default product;
